module.exports = __webpack_public_path__ + "img/icon_chengggong@2x.37f68577.png";